import { useTranslate } from "@tolgee/react";
import { formatPrice, formatUsd } from "../../lib/formatters.ts";

type OrderFormMetricsProps = {
	estimatedLiquidation: number;
	marginRequired: number;
};

export function OrderFormMetrics({
	estimatedLiquidation,
	marginRequired,
}: OrderFormMetricsProps) {
	const { t } = useTranslate();

	return (
		<div className="flex items-center justify-between bg-trade-surface-inset py-1 sm:gap-1">
			<div className="flex items-center justify-between gap-2 text-caption1 text-trade-text-secondary sm:text-label2">
				<span>{t("form.est-liq")}</span>
				<span className="text-caption1-medium sm:text-label2-medium text-trade-text">
					{estimatedLiquidation ? formatPrice(estimatedLiquidation) : "--"}
				</span>
			</div>
			<div className="flex items-center justify-between gap-2 text-caption1 text-trade-text-secondary sm:text-label2">
				<span>{t("form.margin-req")}</span>
				<span className="text-caption1-medium sm:text-label2-medium text-trade-text">
					{formatUsd(marginRequired)}
				</span>
			</div>
		</div>
	);
}
